var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chapter-detail-filedown"},[_c('img',{attrs:{"src":require("../../../../static/img/file-other.png"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"tips"},[_vm._v(_vm._s(_vm.fileTitle))]),_vm._v(" "),_c('div',{staticClass:"homeBtn",on:{"click":_vm.backHome}},[_vm._v("下载")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f20b772","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/chapter-details/chapter-detail/chapter-detail-fileDown.vue
// module id = null
// module chunks = 